import {nowString} from "./datetime-helpers";

class OfficeApi {

    constructor(seamApi) {
        this.api = seamApi;
    }

    async get(params) {
        return  this.api.handleResponse(async () => {
            const response = await this.api.get('/offices', { params : params });
            return response.data;
        });
    }

    async getOffice(id) {
        return  this.api.handleResponse(async () => {
            const response = await this.api.get(`/offices/${id}`);
            return response.data;
        });
    }

}


export default OfficeApi;
